export default ({ dispatch }) =>
  () => {
    dispatch('project/all/changeNotification');
    dispatch('project/starred/changeNotification');
    dispatch('project/latest/changeNotification');
  };
